import type { ToggleRefinementComponentTemplates } from '../../components/ToggleRefinement/ToggleRefinement';

const defaultTemplates: ToggleRefinementComponentTemplates = {
  labelText: '{{name}}',
};

export default defaultTemplates;
